module.exports = __webpack_public_path__ + "static/media/vacation_mode_on_icon.5758c973.svg";